/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ImageShapeEnum = "circle" | "container" | "shipment" | "square" | "vessel" | "voyage" | "%future added value";
export type OverlayIconEnum = "blocked_by_customs" | "%future added value";
export type ItemImage_data = {
    readonly url: string | null;
    readonly alt: string | null;
    readonly highlight: string | null;
    readonly shape: ImageShapeEnum | null;
    readonly overlay: string | null;
    readonly overlayIcon: OverlayIconEnum | null;
    readonly " $refType": "ItemImage_data";
};
export type ItemImage_data$data = ItemImage_data;
export type ItemImage_data$key = {
    readonly " $data"?: ItemImage_data$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemImage_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemImage_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "highlight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shape",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayIcon",
      "storageKey": null
    }
  ],
  "type": "Image",
  "abstractKey": null
};
(node as any).hash = 'dfd1543b0aefd093778092e35567428d';
export default node;
